export const Data = {
    cn:{        
    },
    en: {
    }
};
